'use client';

import { useMessages, useTranslations } from 'next-intl';
import type { NavLink } from '@/constants/navbarMenu';
import { hrefToNavPathKey } from '@/lib/i18n/navPathLabel';
import { resolveNavPathMessage } from '@/lib/i18n/resolveNavPathMessage';

/**
 * Resolves a nav link label: `nav.root.*` for hubs, nested `navPaths.paths` by href, else fallback `label`.
 */
export function useNavPathLabel() {
  const tNav = useTranslations('nav');
  const messages = useMessages();
  const paths = (messages as { navPaths?: { paths?: Record<string, unknown> } }).navPaths?.paths;

  return function resolveNavLabel(link: Pick<NavLink, 'label' | 'i18nKey' | 'href'>): string {
    if (link.i18nKey) {
      const key = link.i18nKey.replace(/^root\./, '');
      return tNav(`root.${key}` as Parameters<typeof tNav>[0]);
    }
    if (link.href) {
      const fromMessages = resolveNavPathMessage(paths, hrefToNavPathKey(link.href));
      if (fromMessages) return fromMessages;
    }
    return link.label ?? '';
  };
}
